function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MainTemplate = require('./main.template');
var StackMain = /*#__PURE__*/function () {
  function StackMain(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, StackMain);
    this.app = app;
    this.mod = mod;
    this.container = container;
  }
  return _createClass(StackMain, [{
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // ========================================================================
      // INVARIANT 4: Unmount before navigating to splash (navigation path: editor → splash)
      // ========================================================================
      if (this.mod.create_post_ui && typeof this.mod.create_post_ui.onEditorUnmount === 'function') {
        this.mod.create_post_ui.onEditorUnmount();
      }
      if (container !== '') {
        this.container = container;
      }
      if (!this.container || this.container.trim() === '') {
        this.container = '.saito-container';
      }
      var html = MainTemplate(this.app, this.mod);

      // ========================================================================
      // FIX: Use replaceElementContentBySelector to preserve .saito-container
      // ========================================================================
      // Ensure container is preserved when rendering splash to avoid conflicts
      // with editor ownership of .saito-container
      if (!document.querySelector('.splash')) {
        this.app.browser.addElementToSelector(html, this.container);
      } else {
        // Replace only the splash content, not the entire container
        this.app.browser.replaceElementContentBySelector(html, '.splash');
      }

      // Update container class
      var containerEl = document.querySelector(this.container);
      if (containerEl) {
        containerEl.classList.add('hide-scrollbar');
        containerEl.classList.add('stack-splash-container');
        containerEl.classList.remove('stack-create-post-container');
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      try {
        var createBtn = document.querySelector('#stack-create-post-btn');
        if (createBtn) {
          createBtn.onclick = function (e) {
            e.preventDefault();
            _this.handleStartWriting();
          };
        }
        var getStartedBtn = document.querySelector('#stack-get-started-btn');
        if (getStartedBtn) {
          getStartedBtn.onclick = function (e) {
            e.preventDefault();
            // ========================================================================
            // INVARIANT 4: Unmount before navigating to explore (navigation path: splash → explore)
            // ========================================================================
            if (_this.mod.create_post_ui && typeof _this.mod.create_post_ui.onEditorUnmount === 'function') {
              _this.mod.create_post_ui.onEditorUnmount();
            }
            _this.mod.exploreOverlay.render();
          };
        }
        var learnMoreBackBtn = document.querySelector('#stack-learn-more-back-btn');
        if (learnMoreBackBtn) {
          learnMoreBackBtn.onclick = function (e) {
            e.preventDefault();
            // Open Stack wiki page in new tab
            window.open('https://wiki.saito.io/en/applications/stack', '_blank');
          };
        }
      } catch (err) {
        console.error('StackMain attachEvents error:', err);
      }
    }

    /**
     * Handle "Start Writing" button click
     * Checks for existing drafts and shows draft chooser if drafts exist
     */
  }, {
    key: "handleStartWriting",
    value: function () {
      var _handleStartWriting = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var hasValidDrafts, intent;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // ========================================================================
              // INVARIANT 4: Unmount before navigating to editor (navigation path: splash → editor)
              // ========================================================================
              // Note: Editor render() will also unmount if already mounted, but we unmount here
              // to ensure clean state when coming from splash
              if (this.mod.create_post_ui && typeof this.mod.create_post_ui.onEditorUnmount === 'function') {
                this.mod.create_post_ui.onEditorUnmount();
              }

              // ========================================================================
              // DRAFT FLOW FIX: Check for drafts before deciding intent
              // ========================================================================
              // Ensure drafts are discovered before checking validity
              if (!this.mod.discoverDrafts) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return this.mod.discoverDrafts();
            case 1:
              // Check if valid drafts exist
              hasValidDrafts = this.mod.hasValidDrafts && this.mod.hasValidDrafts(); // Determine intent based on draft existence
              intent = hasValidDrafts ? {
                mode: 'choose'
              } : {
                mode: 'new'
              }; // Set pending intent before render() so it uses the correct intent
              if (this.mod.create_post_ui) {
                this.mod.create_post_ui.pendingIntent = intent;
              }

              // Render editor - it will use pendingIntent if set, otherwise defaults to 'new'
              this.mod.create_post_ui.render();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleStartWriting() {
        return _handleStartWriting.apply(this, arguments);
      }
      return handleStartWriting;
    }()
  }]);
}();
module.exports = StackMain;